<template>
  <a-card title="用户数据统计">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item label="国家代码">
          <a-input placeholder="Region" v-model:value="formSearch.region" />
        </a-form-item>
        <a-form-item>
          <a-button
            :loading="loading"
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('')"
      >全球</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('CN')"
      >国内</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('OVERSEA')"
      >海外</a-button>
    </a-space>
      <table class="stats-table">
        <legend>{{formSearch.region}} 日新增用户统计</legend>
        <tr>
          <th >日期</th><th>数据</th>
        </tr>
        <tr v-for="(item) in new_user_counts" :key="item.day">
          <td >{{ item.day }}</td><td>{{ item.count }}<div :style="{height: '8px', width: item.count / 100 +'px', background: '#1677ff'}"></div></td>
        </tr>
        
      </table>
      <hr />
  </a-card>
</template>
<script>
import { defineComponent,  onMounted} from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import { useStore } from 'vuex'
import {useRoute} from 'vue-router'

export default defineComponent({
  components: {
    SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      new_user_counts: [],
      loading: false,
       formSearch: {
        region: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['region']) {
      this.formSearch.region = route.query['region']
    }
    this.handleTableChange()
  },
  methods: {
    loadRegion (region) {
      this.formSearch.region = region
      this.handleTableChange()
    },
    async handleTableChange () {
      this.loading = true
      const rsp = await request.get('/api/stats/new_user_counts', {
        ...this.formSearch
      })
      this.loading = false
      this.new_user_counts = rsp.data.result
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #999;
  padding: 4px 8px;
}
</style>